import { useAppSelector } from '@/store/hooks';
import { REF_APP_SLICE_KEY } from '../evaluate.constants';
export const useReferenceApplicationSelector = (selector) => useAppSelector((state) => selector(state[REF_APP_SLICE_KEY]));
